import * as React from "react"
import {useState, useEffect} from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import {FiMenu} from "@react-icons/all-files/fi/FiMenu"
import {FiX} from "@react-icons/all-files/fi/FiX"

const Header = ({ siteTitle }) => {
  const [offset, setOffset] = useState(0)
  
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.onscroll = () => {
        setOffset(window.pageYOffset)
      }
    }
  }, [])

  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);
  
  return (
    <>
    <nav className="navContainer"
        style={{
          backgroundColor: offset > 500?
            '#ffffffcc' : 'transparent',
          zIndex: '10',
          transition: "all 0.5s ease"
        }} >
      <div style={{transition: "all 0.5s ease", zIndex: '100'}}>
        <Link to="/">
          <img src={offset > 500 || click ? "/logo_colour_300.png" : "/logo_white_300.png"} alt={siteTitle} style={{width: 130}}/>
        </Link>
      </div>


      <div className="block z-20 md:hidden" role="button" onClick={handleClick}>
        {click ? (
          <FiX className="menuIconDark" />
        ) : (
          <FiMenu className={offset > 500 ? "menuIconDark" : "menuIconWhite"} />
        )}
      </div>
           
      <ul className={click ?
        "ulActive ulBase" : "ulBurger ulBase"}
        style={{ transition: 'all 0.5s ease', width: '100%' }}>
        <li className="navLinkDark" role="button" onClick={closeMobileMenu}>
          <Link to="/about">ABOUT</Link>
        </li>
        <li className="navLinkDark" role="button" onClick={closeMobileMenu}>
          <Link to="/view-jobs">JOBS</Link>
        </li>
        <li className="navLinkDark" role="button" onClick={closeMobileMenu}>
          <Link to="/join-us">JOIN US</Link>
        </li>
        <li className="navLinkDark" role="button" onClick={closeMobileMenu}>
          <Link to="/contact-us">CONTACT</Link>
        </li>
      </ul>
    </nav>
    </>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header

